// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".572.0.0." + {2239: "21f566ad04def6bd",2733: "0977e6efd5383ca4",2944: "ac69b02f3868e7e5",5233: "f846c236b5b59184",5338: "9d891e4498d32062",8756: "64563b1251310f4f",9289: "230f8d47d3326023",}[chunkId] + ".css"
}